import React, {FC, useEffect, useState} from 'react';
import {useAppSelector} from 'redux/hooks';
import ordersService from "../../api/services/ordersService";
import {setIsNeedUpdateData} from "../../redux/orders/reducer";
import store from "../../redux/store";
import UpdItem from "./UpdItem";
import {t} from "i18next";


export interface Upd {
    id: number,
    order_id: number,
    number: string,
    amount: number,
    date: string,
    xml: string,
    created_at: string,
}


const UpdList: any = ({}) => {
    const [updList, setUpdList] = useState<Upd[]>([]);
    const [isDeleting, setIsDeleting] = useState<boolean>(false);

    const currentOrderId = useAppSelector((state) => state.orders.currentOrderId);
    const isNeedUpdateData = useAppSelector((state) => state.orders.isNeedUpdateData);


    useEffect(() => {
      if(!currentOrderId){
          setUpdList([]);
          return;
      }

        ordersService.getUpdListByOrderID(currentOrderId).then(
            (res) => {
              if (res.data.success) {
                const resData = res.data.data
                  setUpdList(resData)
                  store.dispatch(setIsNeedUpdateData(false))
              }
            },
            (err) => {
              alert('Failed getting order upds: ' + err.message)
                store.dispatch(setIsNeedUpdateData(false))
            }
        )
        .catch((err) => {
          alert('Failed getting order upds: ' + err.message)
            store.dispatch(setIsNeedUpdateData(false))
        })
    ;
    }, [currentOrderId, isNeedUpdateData])


  // @ts-ignore
    return (
        (updList.length > 0)
            ?
            <table className="table-auto w-full mb-2 mt-4">
                 <thead className="text-xs uppercase text-gray-400">
                     <tr className="flex flex-wrap md:table-row md:flex-no-wrap">
                         <th className="w-full block md:w-auto md:table-cell py-2">
                             <div className="font-semibold text-left">Номер</div>
                         </th>
                         <th className="w-full block md:w-auto md:table-cell py-2">
                             <div className="font-semibold text-left">Сумма</div>
                         </th>
                         <th className="w-full block md:w-auto md:table-cell py-2">
                             <div className="font-semibold text-left">Дата</div>
                         </th>
                         <th className="w-full block md:w-auto md:table-cell py-2">
                             <div className="font-semibold text-left">Действия</div>
                         </th>
                     </tr>
                 </thead>
                 <tbody className="text-sm">
                     { updList.map((item, key) =>
                         <UpdItem item={item} updList={updList} setUpdList={setUpdList} key={key}></UpdItem>
                     )
                     }
                 </tbody>
             </table>
            :
            <div className="pt-4 text-center">
                {t("You don't have UPD", { ns: "messages" }) as string}
            </div>

  );
};

export default UpdList;